/*
 * DateBlocks Messages
 *
 * This contains all the text for the DateBlocks component.
 */

import { defineMessages } from "react-intl";

export const scope = "app.components.DateBlocks";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Treatment planner",
  },
  subHeader: {
    id: `${scope}.subHeader`,
    defaultMessage: "Your planned treatments",
  },
  from: {
    id: `${scope}.from`,
    defaultMessage: "From ",
  },
  to: {
    id: `${scope}.to`,
    defaultMessage: "to ",
  },
});
